import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterFormPubModel from "../../Component/registerform/registerPublicModel";

const PaymentRegisterModel = () => {
  return (
    <div>
      <Layout>
        <RegisterFormPubModel
          examType={"MODEL SCREENING EXAMINATION"}
          serviceType={"model"}
          navigateTo={"/model/payment/login"}
          homeLink={"https://screeningtest.examsboard.lagosstate.gov.ng/"}
        />
      </Layout>
    </div>
  );
};

export default PaymentRegisterModel;
